import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import 'react';

import BlockDtDd from '../../ui/definition-list/block-dt-dd';
import DefinitionListHeader from '../../ui/definition-list/definition-list-header';
// import IconDetails from '../../ui/icons/details'; // Comentado se não estiver a ser usado
// import VehiclePreview from '../../ui/vehicle-preview'; // Comentado se não estiver a ser usado

interface PartInfoProps {
  productDetail: TProductDetail;
  showHeader?: boolean;
  id?: string;
}

// No React 18 / Next 14, definimos o forwardRef com os tipos <TipoDaRef, TipoDasProps>
const PartInfo = (
  {
    productDetail,
    showHeader = true,
    id,
    ref
  }: PartInfoProps & React.RefAttributes<HTMLDivElement>
) => {
  const { t } = useTranslation();

  return (
    <div
      id={id}
      className="max-md:px-4 max-lg:pb-4 lg:pt-2 max-lg:container max-lg:mx-auto"
    >
      <div
        id="pp_details"
        ref={ref}
        className="scroll-mt-[316px] lg:scroll-mt-[190px]"
      />

      {showHeader && (
        <DefinitionListHeader
          titleClassName="leading-4"
          title={t('product:part_details')}
        />
      )}

      <div className={cx('my-4 text-sm')}>
        {productDetail.car && (
          <h3>
            <span>
              <strong>{productDetail.car.brand_name}</strong>{' '}
              {productDetail.car.model_name} {productDetail.car.version_name}{' '}
              <br />
              {productDetail.car.years}{' '}
            </span>
            <span className="text-sm leading-5 inline mr-1 font-bold whitespace-no-wrap ">
              ({productDetail.car.door_nr} {t('vehicle:doors')})
            </span>
          </h3>
        )}

        <dl className={cx('grid', 'grid-cols-1')}>
          <BlockDtDd
            span
            dt={t('product:reference')}
            dd={productDetail.reference || '-'}
          />
          <BlockDtDd
            dt={t('vehicle:details.vin')}
            dd={productDetail.vin || '-'}
          />
          <BlockDtDd
            dt={t('vehicle:details.engine_code')}
            dd={productDetail.car.engine || '-'}
          />
          <BlockDtDd
            dt={
              process.env.NEXT_PUBLIC_HOST?.includes('.co.uk')
                ? t('vehicle:details.miles')
                : t('vehicle:details.km')
            }
            dd={
              (productDetail.milageCoUK && productDetail.milageCoUK > 0
                ? productDetail.milageCoUK.toFixed(0)
                : !productDetail.mileage || productDetail.mileage === 0
                  ? '-'
                  : productDetail.mileage) as string
            }
          />
        </dl>
      </div>
    </div>
  );
};

PartInfo.displayName = 'PartInfo';

export default PartInfo;
